import React, { useState, useEffect } from 'react'
import { Button, Modal, Form, Input, Checkbox } from 'antd'
import useAxios from 'axios-hooks'
import { useProjects } from 'context/project-context'
import { notificationToast } from 'components/NotificationToast';
import { getAuthHeader } from 'utils/auth'
import styled from '@emotion/styled'
import { TooltipLabel } from 'components/TooltipLabel';
import { StyledAlert } from 'components';

const StyledModalFooter = styled.div`
	display: grid;
    grid-template-columns: 1fr 1fr;
`;

const StyledButton = styled(Button)`
	margin-left: 0 !important;
	border: none;
    color: white;
	border-radius: unset;
	background: ${props => props.background};
	height: 3.2rem;
	font-size: 1rem
`;


const StyleFormWrapper = styled.div`
	.ant-form-item-control{
		line-height: 2rem;
	};
	.ant-form-item:last-child{
		margin-bottom: 0;
	}
`;

const uRemedaiteProfileTooltip = "Check this box to run the scan without uRemediate profiles enabled to check the accessibility of the native page(s).";
const baseAddressTooltip = "Enter URL web application. ie. http://100.0.0.20:6000";
const CONTAIN_URL_PARAMETER = "contain_url_with_parameter";
const UREMEDIATE_ENABLED = "uremediate_enabled";

const ScanParametersModal = ({ children, openModal, setOpenModal, onRun, error, scanSettingsId, setModalLoading, scanCreateDataSuccess }) => {
	const { project } = useProjects()
	const [baseAddressValue, setbaseAddressValue] = useState("");
	const [uRemedaiteProfileValue, setuRemedaiteProfileValue] = useState(false);
	const [clientError, setClientErrors] = useState(false);
	const [isVisible, setIsVisible] = useState(false);
	const errros = clientError || error;

	const [{ data: infoData, loading: startLoading, error: infoError}, getPreInfo] = useAxios({
		url: `${project.name}/scan-settings/${scanSettingsId}/pre-info`,
		method: 'GET',
		headers: getAuthHeader()
	}, {manual: true})

	useEffect(() => {
		if(scanCreateDataSuccess){
			closeModal();
		}
	}, [scanCreateDataSuccess])

	useEffect(() => {
		if(openModal && openModal.isVisible && openModal.id === scanSettingsId){
			getPreInfo();
		}
	}, [openModal])

	useEffect(() => {
		if(startLoading){
			setModalLoading && setModalLoading(true);
		}
	}, [startLoading])

	useEffect(() => {
		if(infoData){
			setModalLoading && setModalLoading(false);
			if(!infoData[CONTAIN_URL_PARAMETER] && !infoData[UREMEDIATE_ENABLED]){
				onRun();
			}
			else{
				setIsVisible(true);
			}
		}

		if(infoError){
			let infoErrors = infoError && 
				infoError.response && 
				infoError.response.data && 
				infoError.response.data.Errors;

			notificationToast({
				message: 'Error',
				description: `Could not retrive scan settings data. ${infoErrors}`,
				icontype: "alert"
			});
			setModalLoading && setModalLoading(false);
		}

	}, [infoData, infoError])

	const containBaseAddress = infoData && infoData[CONTAIN_URL_PARAMETER];
	const isURemedaiteEnabled = infoData && infoData[UREMEDIATE_ENABLED];

	const closeModal = () => {
		setOpenModal(false);
		setIsVisible(false);
		setbaseAddressValue("");
		setuRemedaiteProfileValue(false)
		setClientErrors(null);
	}

	const onSubmit = (e) => {
		if(baseAddressValue.trim() === "" && !isURemedaiteEnabled){
			setClientErrors(["base address cannot be empty"]);
		}
		else{
			onRun(e, baseAddressValue, uRemedaiteProfileValue);
		}
	}

	return (
		<>      
			{children}
				<Modal
					centered
					width={600}
					title={<h2>SCAN PARAMETERS</h2>}
					visible={isVisible && openModal && openModal.isVisible && openModal.id === scanSettingsId}
					destroyOnClose={true}
					closable={false}
					footer={[
						<StyledModalFooter>
							<StyledButton background="#2747A8" onClick={() => closeModal()} >CANCEL</StyledButton>
							<StyledButton background="#005FDB" onClick={(e) => onSubmit(e)}>RUN</StyledButton>
						</StyledModalFooter>
					]}
				>
					{errros && 
						<StyledAlert
							style={{ marginBottom: 20 }}
							message="Error"
							description={errros}
							type="error"
							showIcon
						/>
					}
					<Form>
						<StyleFormWrapper>
							{ containBaseAddress &&
									<Form.Item name="baseAddress">
										<TooltipLabel 
											required
											fontSizeRem={1}
											marginBottom={0}
											htmlFor="baseAddress" 
											value="$BASE_ADDRESS"
											tooltip={{text: baseAddressTooltip}} 
										/> 
										<Input onChange={(e) => setbaseAddressValue(e.target.value)} id="baseAddress"/>
									</Form.Item>
							}
							{
								isURemedaiteEnabled &&
								<Form.Item name="uRemedaiteProfiles">
									<Checkbox id="uRemedaiteProfiles" onChange={(e) => setuRemedaiteProfileValue(e.target.checked)}>
										<TooltipLabel htmlFor="uRemedaiteProfiles" value="DISABLE UREMEDIATE PROFILES"
											tooltip={{text: uRemedaiteProfileTooltip}} 
										/> 
									</Checkbox>
								</Form.Item>
							}
						</StyleFormWrapper>
					</Form>
				</Modal>
        </>
	)
}

export default ScanParametersModal
